import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M5 10h14","key":"svg-1"}],["path",{"d":"M9 13v3","key":"svg-2"}],["path",{"d":"M9 6v1","key":"svg-3"}]]

const IconFridge = createReactComponent('outline', 'fridge', 'Fridge', __iconNode);

export default IconFridge;